export const ROLES = {
  PLATFORM_ADMIN: "platform_admin",
  TENANT_ADMIN: "tenant_admin",
  SUPPORT_AGENT: "support_agent",
  VIEWER: "viewer",
};

const ROLE_MAP = {
  0: ROLES.PLATFORM_ADMIN,
  1: ROLES.TENANT_ADMIN,
  2: ROLES.SUPPORT_AGENT,
  3: ROLES.VIEWER,
};

export const resolveRole = (role) => {
  if (typeof role === "number") return ROLE_MAP[role] || ROLES.VIEWER;
  return role || null;
};

const getUserRole = (user) => {
  if (!user) return null;
  const raw = user.platform_role || user.user_role || user.role;
  return resolveRole(raw);
};

export const isPlatformAdmin = (user) =>
  user?.role === ROLES.PLATFORM_ADMIN;
export const isTenantAdmin = (user) =>
  !isPlatformAdmin(user) && getUserRole(user) === ROLES.TENANT_ADMIN;
export const isSupportAgent = (user) => getUserRole(user) === ROLES.SUPPORT_AGENT;
export const isViewer = (user) => getUserRole(user) === ROLES.VIEWER;

// --- Primary RBAC helpers (clean, explicit) ---

export const canAccessWorkspace = (user) =>
  isPlatformAdmin(user) || isTenantAdmin(user) || isSupportAgent(user) || isViewer(user);

export const canManagePlatform = (user) => isPlatformAdmin(user);

export const canManageTenant = (user, tenantId) =>
  isPlatformAdmin(user) ||
  (isTenantAdmin(user) && String(user?.tenantId) === String(tenantId));

export const canViewTenant = (user, tenantId) =>
  isPlatformAdmin(user) || String(user?.tenantId) === String(tenantId);

export const isReadOnly = (user) => isSupportAgent(user) || isViewer(user);

// --- Legacy helpers (kept for backward compatibility, prefer new helpers above) ---

export const canManageAllTenants = (user) => isPlatformAdmin(user);

export const canWriteInTenant = (user, tenantId) =>
  isPlatformAdmin(user) ||
  (isTenantAdmin(user) && String(user?.tenantId) === String(tenantId));

export const canCreateTenant = (user) => isPlatformAdmin(user);

export const canAccessAdminConsole = canAccessWorkspace;

export const canAccessTenantAdminScreens = canAccessWorkspace;

export const canAccessOrgManagement = (user) => isPlatformAdmin(user);

export const getAccessDeniedMessage = (action) => {
  if (action === "create_tenant") return "Only platform admins can create tenants.";
  if (action === "manage_orgs") return "Only platform admins can manage organizations.";
  if (action === "admin_console") return "You do not have access to the admin console.";
  return "You do not have access to this area.";
};
